import { Button } from '@iheartjane/reefer';

import { LinkWithBasename } from '@jane/bloom/components/linkWithBasename';

import styles from './dealQualifiedBanner.module.css';

type DealQualifiedBannerProps = {
  discountedAmount: string;
};

export const DealQualifiedBanner = ({
  discountedAmount,
}: DealQualifiedBannerProps) => {
  return (
    <div className={styles['dealQualifiedContainer']}>
      <div>High five! You saved {discountedAmount}</div>
      <div className={styles['dealQualifiedButtons']}>
        <LinkWithBasename to="/" className={styles['dealQualifiedButton']}>
          <Button variant="tertiary" label="Go home" full />
        </LinkWithBasename>
        <LinkWithBasename
          to="/checkout"
          className={styles['dealQualifiedButton']}
        >
          <Button variant="primary" label="View bag" full />
        </LinkWithBasename>
      </div>
    </div>
  );
};
